import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { ErrorService } from "../../../control-core/services/error.service";
import { IOrdenPago } from "../../models/ser/ordenpago.model";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import { moneymask, SYMBOL_COP, SYMBOL_USD } from "../../../control-core/util/moneymask.util";
import { ITipoTable } from "../../models/general/tipo.model";
import { initWaitMe, stopWaitMe, WaitMeOptionModel } from "../../../control-core/util/waitme.util";
import Swal from 'sweetalert2'
import { AuthService } from '../../../control-core/services/auth.service';
import { Subscription } from 'rxjs/Subscription';
import { IUserC, UserCModel } from '../../models/user.model';


import * as cloneDeep from 'lodash/cloneDeep';
import { GeparametersService } from '../../../control-core/services/geparameters.service';
import { ValidatorService } from "../../../control-core/services/validator-service";
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-detalle-orden-pago',
  templateUrl: 'detalle-orden-pago.component.html',
  styleUrls: ['detalle-orden-pago.component.css']
})
export class DetalleordenpagoComponent implements OnChanges {

  @Input() referenciapago: string;

  @Output() onAnulado: EventEmitter<{ success: boolean, msg: string }> = new EventEmitter();
  @Output() onComprobado: EventEmitter<{ success: boolean, msg: any }> = new EventEmitter();

  objetoPago: IOrdenPagoDetalleOrden;
  mostrarBoton: boolean = false;
  mostrarUpload: boolean = false;
  bloqueaBoton: boolean = false;
  convBaloto: string = '';
  cuentaOccidente: string = '';
  linkPSE: string = '';
  ayudaMetodoPago: string = '';
  tucompraselects: string = '';
  infoPagoForm: FormGroup = new FormGroup({
    getipo_id: new FormControl('', [Validators.required]),
    identificacion: new FormControl('', [Validators.required, this._validatorService.soloNumerosFormValidator]),
  });

  public archivoLbl = this._translate.instant('FILE_LABEL');
  public uploadLbl = this._translate.instant('UPLOAD_FILE_LABEL');
  public removeLbl = this._translate.instant('REMOVE_FILE_LABEL');
  public _ORDEN_PAGADA_LABEL = this._translate.instant("ORDEN_PAGADA_LABEL");
  public _ORDEN_PORCOMPROBAR_LABEL = this._translate.instant("ORDEN_PORCOMPROBAR_LABEL");
  public _ORDEN_PENDIENTE_LABEL = this._translate.instant("ORDEN_PENDIENTE_LABEL");
  public _YES_LABEL = this._translate.instant('YES_LABEL');
  public _NO_LABEL = this._translate.instant('NO_LABEL');
  public listaEntidades: Array<{ id: string, nombre: string }>;
  public accept = 'image/png,image/jpeg,application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
      'application/pdf,image/bmp';
  public files: File[] = [];
  public hasBaseDropZoneOver: boolean = false;
  public sendableFormData: FormData;
  public tuCompraFormData: FormData;
  public infoCliente: IUserC = new UserCModel();

  private confirmaAnul = this._translate.instant('CONFIRM_ANUL_LABEL');
  private datosReciboPago = {getipo_id: '', identificacion: ''};
  private _infoCliente$Unsubscribe: Subscription = null;
  private _geparametersSubscription: Subscription = null;

  constructor(private _http: HttpClient,
              private _translate: TranslateService,
              private _errorService: ErrorService,
              private _parameters: GeparametersService,
              private _validatorService: ValidatorService,
              private _authService: AuthService) {
  }

  ngOnInit() {
    this.mostrarUpload = false;
    this._infoCliente$Unsubscribe = this._authService.userInfo$
        .subscribe((iUserInfo: IUserC) => {
          this.infoCliente = cloneDeep(iUserInfo);
          this.infoPagoForm.setValue({identificacion: this.infoCliente.identificacion, getipo_id: ''})
        });
    this._geparametersSubscription = this._parameters.state$.subscribe((estado) => {
      if (estado == 'ready') {
        this.convBaloto = this._parameters.getStrval('CTRBX_CONVENIO_BALOTO');
        this.cuentaOccidente = this._parameters.getStrval('CUENTA_BANCO_OCCIDENTE');
        this.linkPSE = this._parameters.getStrval('LINK_PAGO_PSE');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.objetoPago = new OrdenPagoDetalleOrdenModel();
    this.listaEntidades = [];
    this.mostrarBoton = false;
    this.bloqueaBoton = false;
    this.mostrarUpload = false;
    this.files.splice(0, 1);
    if (changes.referenciapago.currentValue != '' && changes.referenciapago.currentValue != null) {
      this.consultadetalle();
      this.getEntidades();
    }
  }

  consultadetalle() {
    let optionWait = new WaitMeOptionModel();
    optionWait.effect = 'win8';
    initWaitMe('#detalle_pago_panel', optionWait);
    this._http.get<IOrdenPagoDetalleOrden>(`${CONTROL_APP_CONST.API_URL}consultaOrdenPago/${this.referenciapago}`)
        .map((response) => {
          response['totaluss'] = moneymask(response.totalpago, SYMBOL_USD);
          response['totalcops'] = moneymask(response.totalpagocop, SYMBOL_COP);
          this.mostrarBoton = !response.pagada && !response.porcomprobar;
          if (response.pagada) {
            response['estado'] = this._ORDEN_PAGADA_LABEL;
          }
          else if (response.porcomprobar) {
            response['estado'] = this._ORDEN_PORCOMPROBAR_LABEL;
          }
          else {
            response['estado'] = this._ORDEN_PENDIENTE_LABEL;
          }
          return response;
        })
        .subscribe(
            (response) => {
              this.objetoPago = response;
            }, (error) => {
              this._errorService.manejaError(error);
            }, () => {
              stopWaitMe('#detalle_pago_panel');
            }
        )
  }

  anularOrden() {
    this.bloqueaBoton = true;
    Swal({
      title: '',
      html: '<span style="font-size: 15px">' + this.confirmaAnul + '</span>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {
        this._http.put<string>(`${CONTROL_APP_CONST.API_URL}anularOrdenPago/${this.objetoPago.pago_id}`, {})
            .subscribe(
                (response) => {
                  this.bloqueaBoton = false;
                  this.onAnulado.emit({success: true, msg: response});
                }, (error) => {
                  this.bloqueaBoton = false;
                  this.onAnulado.emit({success: false, msg: error.error});
                }
            )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.bloqueaBoton = false;
      }
    });
  }

  pagoPaypal() {
    window.open(`${CONTROL_APP_CONST.API_URL}paypalOrdenPagoPagar/${this.objetoPago.refinterna}`, "_self");
  }

 sendToTuCompra(){

  const tuCompraFormData = new FormData();

  tuCompraFormData.append('factura', this.objetoPago.refinterna);
  tuCompraFormData.append('valor', `${this.objetoPago.totalpagocop}`);
  tuCompraFormData.append('descripcionFactura', `pago de orden ${this.objetoPago.totalpagocop}`);
  tuCompraFormData.append('usuario', `${CONTROL_APP_CONST.TU_COMPRA_TERMINAL}`);
  console.log(tuCompraFormData)

  const req = new HttpRequest<FormData>('POST', `${CONTROL_APP_CONST.API_URL}tuCompraOrdenPagoPagar`, tuCompraFormData,{
    reportProgress: true
  });
  this._http.request(req)
        .subscribe(
          (event) => {
            if (event instanceof HttpResponse) {
              const responseObject = event.body as { url: string } | undefined;
              // Verifica si la respuesta contiene la URL
              if (responseObject && responseObject.url) {
                const absoluteUrl = new URL(responseObject.url, window.location.origin).href;
                window.open(absoluteUrl, "_blank");
              } else {
                console.error("La respuesta no contiene una URL válida.");
              }
            }
          },
            (error) => {
              console.log(error)
              this._errorService.manejaError(error);
            },
            () => {
              this.onComprobado.emit({success: true, msg: 'enviado OK'});
            }
            
        )
  this.tucompraselects = '';
 }

  getEntidades() {
    this._http.get<ITipoTable[]>(`${CONTROL_APP_CONST.API_URL}tiposControlBoxex`, {params: {grupo: 'ENTIDADES_PAGO'}})
        .subscribe(
            (response) => {
              response.forEach((value) => {
                this.listaEntidades.push({id: value.id, nombre: value.nombre});
              });
            },
            (error) => {
              console.log(error.error);
            }
        )
  }

  checkInfoPagoForm() {
    this.datosReciboPago = this.infoPagoForm.value;
    return !this.infoPagoForm.valid;
  }

  agregarInformacion() {
    if (this.checkInfoPagoForm()) {
      return false;
    }
    let optionWait = new WaitMeOptionModel();
    optionWait.effect = 'win8';
    initWaitMe('#informacion_pago_panel', optionWait);
    this.sendableFormData.append('getipo_id', this.datosReciboPago.getipo_id);
    this.sendableFormData.append('serordenpago_id', this.objetoPago.pago_id);
    if (this.infoCliente.identificacion != this.datosReciboPago.identificacion) {
      this.sendableFormData.append('doc_identificacion', this.datosReciboPago.identificacion)
    }
    const req = new HttpRequest<FormData>('POST', `${CONTROL_APP_CONST.API_URL}addDataPago`, this.sendableFormData, {
      reportProgress: true
    });
    this._http.request(req)
        .subscribe(
            (response) => {
            },
            (error) => {
              stopWaitMe('#informacion_pago_panel');
              this._errorService.manejaError(error);
            },
            () => {
              this.datosReciboPago.getipo_id = '';
              this.mostrarUpload = false;
              this.files.splice(0, 1);
              stopWaitMe('#informacion_pago_panel');
              this.onComprobado.emit({success: true, msg: 'COMPROBACION_CORRECTA_LABEL'});
            }
        )
  }

  ngOnDestroy() {
    this._infoCliente$Unsubscribe.unsubscribe();
    this._geparametersSubscription.unsubscribe();
  }
}

export interface IOrdenPagoDetalleOrden extends IOrdenPago {
  totaluss: string;
  totalcops: string;
  estado: string;
}

export class OrdenPagoDetalleOrdenModel implements IOrdenPagoDetalleOrden {
  totaluss: string;
  totalcops: string;
  estado: string;
  pago_id: string;
  refinterna: string;
  fechavencimiento: string;
  totalpago: number;
  totalpagocop: number;
  pagada: boolean;
  whr_id: string;
  nrowhr: string;
  created_at: string;
}


// WEBPACK FOOTER //
// ./src/app/control-app/shared/detalleordenpago/detalle-orden-pago.component.ts